// removed by extract-text-webpack-plugin
module.exports = {"outerContainer":"outerContainer__2Jrcn","coloredContainer":"coloredContainer__H0urN","mobileScreen":"mobileScreen__QEDp2","mobileScreenimg":"mobileScreenimg__1RsZa","imgContainer":"imgContainer__12yID","content":"content__Fi9L8","contentHeader":"contentHeader__3PKb5","contentContainer":"contentContainer__3CpC6","contentSubHeader":"contentSubHeader__3WJGp","checkEligibleBtn":"checkEligibleBtn__3Eenc","innerContent":"innerContent__1dDQ6","successLogo":"successLogo__3NaXd","checkEligibleLayout":"checkEligibleLayout__2pV2W"};


//////////////////
// WEBPACK FOOTER
// ./routes/program-landing-page/components/userStatus/style.css
// module id = /0MA
// module chunks = 380